import FormSection from './FormSection'
import { translations } from '../../data/translations'
import './FormSection.css'

const DesignSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.design || translations.de.design

  const handleCheckboxChange = (field, value, checked) => {
    const current = formData[field] || []
    const updated = checked
      ? [...current, value]
      : current.filter(v => v !== value)
    updateFormData(field, updated)
  }

  return (
    <FormSection title={t.title} subtitle={t.subtitle}>
      <h3 className="form-section__subtitle">{t.subtitle1}</h3>
      
      <div className="form-group">
        <label className="form-group__label">{t.designStilLabel}</label>
        <div className="checkbox-group">
          {t.designStilOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="checkbox"
                name="design_stil[]"
                value={option.value}
                checked={(formData.design_stil || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('design_stil', option.value, e.target.checked)}
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="stil_beschreibung" className="form-group__label">
          {t.stil_beschreibung}
        </label>
        <input
          type="text"
          id="stil_beschreibung"
          name="stil_beschreibung"
          className="form-group__input"
          placeholder={t.stil_beschreibungPlaceholder}
          value={formData.stil_beschreibung || ''}
          onChange={(e) => updateFormData('stil_beschreibung', e.target.value)}
        />
      </div>

      <div className="form-group">
        <label htmlFor="farbschema" className="form-group__label">
          {t.farbschema}
        </label>
        <input
          type="text"
          id="farbschema"
          name="farbschema"
          className="form-group__input"
          placeholder={t.farbschemaPlaceholder}
          value={formData.farbschema || ''}
          onChange={(e) => updateFormData('farbschema', e.target.value)}
        />
        <div className="help-text">{t.farbschemaHelp}</div>
      </div>

      <h3 className="form-section__subtitle">{t.subtitle2}</h3>

      <div className="form-group">
        <label className="form-group__label">{t.brandingVorhandenLabel}</label>
        <div className="checkbox-group">
          {t.brandingVorhandenOptions.map((option) => (
            <label key={option.value} className="radio-group__option">
              <input
                type="checkbox"
                name="branding_vorhanden[]"
                value={option.value}
                checked={(formData.branding_vorhanden || []).includes(option.value)}
                onChange={(e) => handleCheckboxChange('branding_vorhanden', option.value, e.target.checked)}
              />
              <span className="radio-group__label">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <h3 className="form-section__subtitle">{t.subtitle3}</h3>

      <div className="form-group">
        <label className="form-group__label">{t.referenzenLabel}</label>
        {[1, 2, 3].map((num) => (
          <div key={num} className="form-grid" style={{ marginBottom: '12px' }}>
            <input
              type="url"
              name={`ref_gefaellt_url_${num}`}
              className="form-group__input"
              placeholder="https://..."
              value={formData[`ref_gefaellt_url_${num}`] || ''}
              onChange={(e) => updateFormData(`ref_gefaellt_url_${num}`, e.target.value)}
            />
            <input
              type="text"
              name={`ref_gefaellt_grund_${num}`}
              className="form-group__input"
              placeholder={t.gefaelltGrundPlaceholder}
              value={formData[`ref_gefaellt_grund_${num}`] || ''}
              onChange={(e) => updateFormData(`ref_gefaellt_grund_${num}`, e.target.value)}
            />
          </div>
        ))}
      </div>
    </FormSection>
  )
}

export default DesignSection
